import React, { Component, cloneElement } from 'react';
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, SelectInput, DateInput } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../spinner';
import myDataProvider from '../myRestProvider';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';

const selectInputStyle = {
    width: 200,
};

const InAppFilter = (props) => (
    <Filter {...props}>
        <TextInput 
        // label="Sms text" 
        source="text"/>
        <TextInput label="Purpose" source="purpose"/>
        <SelectInput style={selectInputStyle} 
        // label="Target type" 
        source="target_type" choices={[
            { id: 'Country', name: 'All Sales Officers' },
            { id: 'SalesOfficer', name: 'A set of Sales Officers' },
        ]}
        />
        <DateInput source="from_date"  
        // label="SMS date from" 
         />
        <DateInput source="to_date"  
        // label="SMS date to"  
        />
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
            <RefreshButton />
        </TopToolbar>
    )
}

class SoSendMessageList extends Component {
    state = {
        modalShow: false,
    }
    exporter = (data) => {
        const msg = data[0].message;
        this.setState({
            modalShow: true,
            modalMsg: msg,
        })
    }

    onClose = () => {
        this.setState({
            modalShow: false,
        })
    }

    render() {
        const { state, props, permissions } = this;
        return (
            <React.Fragment>
                <Scrollbars className="scroll-container" >
                    <List {...props} exporter={this.exporter} sort={{ field: 'created_at', order: 'DESC' }}  filters={<InAppFilter />} title="Send Message" bulkActionButtons={false} actions={<ListActions permissions={permissions} />}>
                        <Datagrid rowClick="show">
                            <TextField 
                            // label="Purpose" 
                            source="purpose" style={textFieldStyle} allowEmpty />
                            <TextField 
                            // label="Sms text" 
                            source="text" style={textFieldStyle} allowEmpty />
                            <TextField 
                            // label="Target type" 
                            source="target_type" sortable={false} allowEmpty />
                            {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                            <DateField 
                            // label="Created At" 
                            source="created_at" showTime />
                            <ShowButton />
                        </Datagrid>
                    </List>
                </Scrollbars>
                {
                    state.modalShow &&
                    <Modal open={state.modalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                }
            </React.Fragment>
        )
    }
}

export default SoSendMessageList;